<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.736 32.456">
    <path
      id="Path_833"
      data-name="Path 833"
      d="M15.779,6.373c-6.225,4-9.247,8.12-9.247,15.011a3.547,3.547,0,0,1,1.127-.128,6.11,6.11,0,0,1,6.4,6.173c0,4.124-2.638,6.686-6.4,6.686C2.792,34.116,0,30.222,0,23.229,0,13.495,4.483,6.5,12.859,1.66Zm17.931,0c-6.225,4-9.247,8.12-9.247,15.011a3.547,3.547,0,0,1,1.127-.128,6.11,6.11,0,0,1,6.4,6.173c0,4.124-2.638,6.686-6.4,6.686-4.841,0-7.634-3.894-7.634-10.887,0-9.734,4.483-16.727,12.859-21.569l2.92,4.713Z"
      transform="translate(0 -1.66)"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
